<div style="display:flex;flex-wrap:wrap;">
  <div id="controlPalette" *ngFor="let control of nonInputControls" cdkDropList [cdkDropListData]="nonInputControls" #controlList [cdkDropListConnectedTo]="connectedDropLists"
  [cdkDropListEnterPredicate]="enterPredicate">
    <div class="formControl" cdkDrag [cdkDragData]="control" (cdkDragStarted)="dragStart()" (cdkDragEnded)="dragEnd()">
      <img [id]="'img' + control.ControlType" [alt]='control.ControlType'
        src='./assets/images/{{control.ControlType | getControlImage}}' />
        <div *cdkDragPreview style="position: relative; top:20px; left:20px;">
            <img [id]="'img' + control.ControlType" [alt]='control.ControlType'
            src='./assets/images/{{control.ControlType | getControlImage}}' />
        </div>
        <e-form-control *cdkDragPlaceholder class="dropItem" [control]="control" style="padding:5px"></e-form-control>
    </div>
  </div>
</div>
<div *ngIf="!readOnly">Input Controls</div>
<div style="display:flex;flex-wrap:wrap;" *ngIf="!readOnly">
  <div id="controlPaletteInput" *ngFor="let control of inputControls" cdkDropList [cdkDropListData]="inputControls" #controlList [cdkDropListConnectedTo]="connectedDropLists"
  [cdkDropListEnterPredicate]="enterPredicate">
    <div class="formControl" cdkDrag [cdkDragData]="control" (cdkDragStarted)="dragStart()" (cdkDragEnded)="dragEnd()">
      <img [id]="'img' + control.ControlType" [alt]='control.ControlType'
        src='./assets/images/{{control.ControlType | getControlImage}}' />
        <div *cdkDragPreview style="position: relative; top:20px; left:20px;">
            <img [id]="'img' + control.ControlType" [alt]='control.ControlType'
            src='./assets/images/{{control.ControlType | getControlImage}}' />
        </div>
        <e-form-control *cdkDragPlaceholder class="dropItem" [control]="control" style="padding:5px"></e-form-control>
    </div>  
  </div>
</div>